import getEvent from '../../../../Apis/event/getEvent'
import selectedOrgId from '../../../../utils/helpers/selectedOrgId'

const calendarIdBreadcrumb = async (data) => {
  const { match, pairedOrgId } = data || {}
  const { eventId } = match.params

  const eventTitle = await getEvent({ eventId, orgId: pairedOrgId || selectedOrgId() }).then(
    (event) => event.title,
  )

  return ['CALENDAR', eventTitle.toUpperCase()]
}

export default calendarIdBreadcrumb
